import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TaxctcService } from '../../../../_services/taxctc/taxctc.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';

@Component({
  selector: 'app-bonus-form',
  templateUrl: './bonus-form.component.html',
  styleUrls: ['./bonus-form.component.scss']
})
export class BonusFormComponent implements OnInit {
  bonusform 
  rowData: any;
  form: FormGroup;
  tenantId: string;
  currentUser: any;
  selectedCheckboxData = []
  deleteConfirmationMsg = 'Are you sure you want to delete'
  bonusId: any;
  getUserName: any;
  userDropdownList = [];
  taxregimDropdownList = [];
  tdsIgnoreMonthsArray : any[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

  constructor(
    private formBuilder: FormBuilder,
    private storageService: LocalStorageService, 
    private allocationService: AllocationService,
    private router: Router,
    private route: ActivatedRoute,
    private taxctcService :TaxctcService
  ) { 
    this.bonusform = this.formBuilder.group({
    employeeId: new FormControl(''),
    financialYear: new FormControl(''),
    ctc: new FormControl(''),
    startMonth: new FormControl(''),
    endMonth: new FormControl(''),
    componentName: new FormControl(''),
    componentValue: new FormControl(''),
    miscellaneous: new FormControl(''),
    deduction: new FormControl(''),
    taxRegimeNo: new FormControl(''),
    employeeName: new FormControl(''),
    tdsIgnoreMonths: new FormControl(''),
    tdsIgnoreMonthsValues: new FormControl(''),
    absolute: new FormControl(''),
    type: new FormControl(''),
    remark: new FormControl('')
  })
}

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.bonusform.value.componentName = "Bonus";
    this.bonusform.patchValue(this.bonusform.value);
    this.bonusId = this.route.snapshot.paramMap.get('id');
    if (this.bonusId) this.getUserBonusById(this.bonusId)
    this.getUserList();
  }

  getUserList() {
    this.userDropdownList = [];
    this.allocationService.getUserDetails().subscribe((response) => {
      this.getUserName = response;
      for (let item of response) {
        this.userDropdownList.push(
          `${item.id} . ${item.firstName} ${item.lastName}`
        );
      }
    });
  }

  getUserBonusById(id){
    this.taxctcService.getuserCtcsById(id).subscribe((response) => {
      if(response) {
        this.bonusform.patchValue(response);
        const array = response.tdsIgnoreMonths?.split(',');
        this.bonusform.value.tdsIgnoreMonths = array;
        this.bonusform.value.employeeId = this.bonusform.value.employeeId + " . " + this.bonusform.value.employeeName;
        this.bonusform.patchValue(this.bonusform.value);
      }
    }, (error) =>{
      
    });
  }
  
  createUserBonus() {
    let tdsIgnoredMonth = this.bonusform.get('tdsIgnoreMonths').value?.toString();
    let details = {
      employeeId: this.bonusform.get('employeeId') ? this.bonusform.get('employeeId').value.split(' . ')[0] : null,
      employeeName: this.bonusform.get('employeeId') ? this.bonusform.get('employeeId').value.split(' . ')[1] : null,
      financialYear: this.bonusform.get('financialYear').value,
      ctc: this.bonusform.get('ctc').value,
      startMonth: this.bonusform.get('startMonth').value,
      endMonth: this.bonusform.get('endMonth').value,
      componentName: this.bonusform.get('componentName').value,
      componentValue: this.bonusform.get('componentValue').value,
      miscellaneous: this.bonusform.get('miscellaneous').value,
      deduction: this.bonusform.get('deduction').value,
      taxRegimeNo: this.bonusform.get('taxRegimeNo').value,
      tdsIgnoreMonths: tdsIgnoredMonth,
      tdsIgnoreMonthsValues: this.bonusform.get('tdsIgnoreMonthsValues').value,
      absolute: this.bonusform.get('absolute').value,
      type: "bonus",
      remark: this.bonusform.get('remark').value
    }
    this.taxctcService.createuserCtcs(details).subscribe((response: any) => {
      // update grid after creating new contact & close the modal
      this.backToBonusList();
    });
  }

  backToBonusList() {
    this.router.navigate([this.tenantId + '/dashboard/finance/bonus']);
  }

  updateUserBonus() {
    let tdsIgnoredMonth = this.bonusform.get('tdsIgnoreMonths').value?.toString();
    let details = {
      //id: this.taxmetadataform.get('id').value,
      employeeId: this.bonusform.get('employeeId') ? this.bonusform.get('employeeId').value.split(' . ')[0] : null,
      employeeName:this.bonusform.get('employeeId') ? this.bonusform.get('employeeId').value.split(' . ')[1] : null,
      financialYear: this.bonusform.get('financialYear').value,
      ctc: this.bonusform.get('ctc').value,
      startMonth: this.bonusform.get('startMonth').value,
      endMonth: this.bonusform.get('endMonth').value,
      componentName: this.bonusform.get('componentName').value,
      componentValue: this.bonusform.get('componentValue').value,
      miscellaneous: this.bonusform.get('miscellaneous').value,
      deduction: this.bonusform.get('deduction').value,
      taxRegimeNo: this.bonusform.get('taxRegimeNo').value,
      tdsIgnoreMonths: tdsIgnoredMonth,
      tdsIgnoreMonthsValues: this.bonusform.get('tdsIgnoreMonthsValues').value,
      absolute: this.bonusform.get('absolute').value,
      type: "bonus",
      remark: this.bonusform.get('remark').value
    }
    // console.log("details", details)
    this.taxctcService.updateuserCtcs(details, this.bonusId).subscribe(res => {
      this.selectedCheckboxData = [];
      this.backToBonusList();
    });
  }

}